import { getToken, getMessaging } from "firebase/messaging";
import app from "./firebaseKeys";
import { STORAGE_KEYS, getFromStorage, setToStorage } from "../helpers";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalStorage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalStorage) {
        return tokenInLocalStorage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BI-w6jbH5r8t4S-Ak1bGacEnen_r7nOtPz2JEa9MkTRDfsDq0I0JvFp1lJRDiKkt6kkzizWG-JIeLQkwKn-dczQ",
        });

        if (fcm_token) {
          console.log({ fcm_token });
          await setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  },
};

export { firebaseCloudMessaging };
